import 'stylesheets/front/new_portal_recommend_area.css';
